//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ClassCreated, ClassUpdated } from 'redux/actions';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";
import CustomSelect from "components/Select/Select.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Location from "@material-ui/icons/LocationOn";
import Photos from "@material-ui/icons/CameraOutlined";
import Calendar from "@material-ui/icons/CalendarTodayOutlined";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
  
class ClassEditor extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      classroom: props.classroom
    };

    this.saveClass = this.saveClass.bind(this);
    this.updateClass = this.updateClass.bind(this);

    this.deletePhoto = this.deletePhoto.bind(this);
    this.updatePhoto = this.updatePhoto.bind(this);
    this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
    this.makeThumbPhoto = this.makeThumbPhoto.bind(this);
  }

    handleClickOpen(modal) {
      console.log("open");
      console.log(this.props);
      this.updateClass('SchoolID',this.props.SchoolID);

      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateClass(property, value) {
      var classroom = this.state.classroom;
      classroom[property] = value;
      this.setState({classroom: classroom});
    }

    addPhoto(url) {

      var classroom = this.state.classroom;
      if(!classroom.Photos) {
        classroom.Photos = [];
      }

      var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

      classroom.Photos.push(photo);
      this.setState({classroom:classroom});
    }

    updatePhoto(photo) {
      var classroom = this.state.classroom;
      
      for(var i = 0; i < classroom.Photos.length; i++) {
        if(classroom.Photos[i].ID === photo.ID) {
            classroom.Photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var classroom = this.state.classroom;

      for(var i = classroom.Photos.length - 1; i > -1; i--) {
        if(classroom.Photos[i].ID === photo.ID) {
            classroom.Photos.splice(i,1);
          break;
        }
      }

      this.setState({classroom:classroom});
    }

    makeCoverPhoto(photo) {
      var classroom = this.state.classroom;
      
      for(var i = 0; i < classroom.Photos.length; i++) {
        if(classroom.Photos[i].ID === photo.ID) {
            classroom.Photos[i].isCover = true;
        } else {
            classroom.Photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var classroom = this.state.classroom;
      
      for(var i = 0; i < classroom.Photos.length; i++) {
        if(classroom.Photos[i].ID === photo.ID) {
            classroom.Photos[i].isThumb = true;
        } else {
            classroom.Photos[i].isThumb = false;
        }
      }
    }

    saveClass() {
    
      db.updateClass(this.state.classroom.id, this.state.classroom).then(doc => {
      
        this.props.onChange();

        if(!this.state.classroom.id) { // i.e. if it's a new class
          this.updateClass("id", doc.id);
          this.props.onClassCreated(this.state.classroom);

          ReactGA.event({
            category: 'Class',
            action: 'Created a New Class'
          });
        } else { // i.e. an existing class
          this.props.onClassUpdated(this.state.classroom);

          ReactGA.event({
            category: 'Class',
            action: 'Updated a Class'
          });
        }
      });
  }
        
    // photos
    photoUploadStart = () => this.setState({isUploading: true, progress: 0});
    photoUploadProgress = (progress) => this.setState({progress});
    photoUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    photoUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
    };


    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            fullScreen
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Class</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.classroom.IsVisible}
                        onChange={(e) => this.updateClass("IsVisible", e.target.checked)}
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="Visible"
                  />
                  <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveClass();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Location,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              id="name"
                              labelText="Name"
                              value={this.state.classroom.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateClass("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomSelect
                                labelText="Grade Level"
                                value={this.state.classroom.GradeLevel}
                                inputProps={{
                                    placeholder: "Grade Level"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateClass("GradeLevel", e.target.value)}
                                options={[ { key:"0-1", label:"K-1" }, {key:"2-3", label:"2-3" }, {key:"4-5", label:"4-5" }, {key:"6-8", label:"6-8" }]}
                              />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                                id="description"
                                labelText="Description"
                                value={this.state.classroom.Description}
                                inputProps={{
                                    placeholder: "Description",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateClass("Description", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={6} sm={6} md={6}>
                            
                          </GridItem>
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.classroom.Photos.map(photo => (
                              <PhotoCard key={photo.id} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  },
                  {
                    tabName: "Calendar",
                    tabIcon: Calendar,
                    tabContent: (
                      <GridContainer style={{minHeight:"300px"}}>
                        <GridItem xs={12} sm={12} md={12}>
                            
                          </GridItem>
                      </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onClassCreated: ClassCreated, onClassUpdated: ClassUpdated}, dispatch);  
}

ClassEditor = connect(mapStateToProps, mapDispatchToProps)(ClassEditor);
export default withStyles(modalStyle)(ClassEditor);


// WEBPACK FOOTER //
// ./src/components/ClassEditor/ClassEditor.jsx